/**
 * Created by litao on 2018/10/23.
 */
import "element-ui/lib/theme-chalk/index.css";
import Element from "element-ui";
import EasyScroll from "easyscroll";
import routerTable from "./router/routerTable";
import routerBefore from "./router/routerBefore";
import restApi from "./http/restApi";
import httpMocks from "./http/mock/intercept";
import methods from "./methods";
import scanWraps from "./warp";
import Encrypt from "./encrypt";
import JBootComponent from "jboot-component";

//avue 配置
import AvueFormDesign from "../avue/main-component/index";
import AvueUeditor from "avue-plugin-ueditor";
import Avue from "@smallwei/avue";
import "@smallwei/avue/lib/index.css";

const keyMapping = {},
  requestIsEncrypt = process.env.NODE_ENV === "production";

export default function(context) {
  //安装elementUI
  context.install(Element, { size: "mini" });

  context.$configure.set("methods", methods);

  context.install(JBootComponent, {
    upload: {
      urlField: "attachment",
      //url: 'http://47.105.197.148:5891/system/attachment/upload', //所有上传都请求这个路径
      url:
        process.env.NODE_ENV === "production"
          ? "/__api/system/attachment/upload"
          : "http://47.105.197.148:5891/system/attachment/upload", //所有上传都请求这个路径
    },
  });

  setTimeout(() => {
    [
      { field: "$success", type: "success" },
      { field: "$warn", type: "warning" },
      { field: "$info", type: "success" },
      { field: "$error", type: "error" },
    ].forEach(
      ({ field, type }) =>
        (context.$vue.prototype[field] = (message) =>
          setTimeout(() =>
            Element.Message({
              message,
              type,
            })
          ))
    );
  });

  //安装滚动条插件
  context.install(EasyScroll);
  context.install(Avue);
  context.install(AvueFormDesign);
  context.install(AvueUeditor);

  //获取百度token
  context.$configure.set("getBdAudioApiToken", function() {
    return context.$vue.prototype.$nativeAjax
      .get(
        `/bdApiAuth/oauth/2.0/token?grant_type=client_credentials&client_id=pw152BzvaSZVwrUf3Z2OHXM6&client_secret=fa273cc704b080e85ad61719abbf7794`
      )
      .then((response) => {
        let accessToken = (response.data || {}).access_token;

        if (accessToken) {
          return accessToken;
        } else {
          throw "调用百度api时，出现异常，请检查代理设置";
        }
      });
  });

  //语音合成选填参数
  context.$configure.set("audioRequestParams", {
    per: 106,
    vol: 15,
  });

  //请求加密
  context.$configure.set("requestIsEncrypt", false);

  //内置log打印
  context.$configure.set("inlayLog", process.env.NODE_ENV !== "production");

  //初始化全局封装
  context.$configure.set("globalWrap", scanWraps(context.utils.extractName));

  //设置http请求需要用到的httpToken的key值
  //context.$configure.set('tokenKey', 'Authorization');
  context.$configure.set("tokenKey", "live-token");

  //配置入口文件
  context.$configure.set("rootFileConfigure", function() {
    return {
      instance: function() {
        return require("../Root.vue").default;
      },
    };
  });
  context.$configure.set("requestBeforeSend", function(config) {
    let data = config.data;

    if (data) {
      if (
        ![undefined, null, ""].includes(data.pageSize) &&
        !config.url.includes("pageNum")
      ) {
        let pageParamStr = ["pageNum", "pageSize"]
          .map((name) => `${name}=${data[name]}`)
          .join("&");

        config.url = config.url.includes("?")
          ? config.url + "&" + pageParamStr
          : config.url + "?" + pageParamStr;
      }
    }
    config.headers["requestType"] = "admin";
  });

  //路由模式
  context.$configure.set("routerMode", "history");

  //自动注册组件上下文
  context.$configure.set(
    "componentContext",
    require.context("@/components/", true, /\.vue$/)
  );

  //路由表配置
  context.$configure.set("routerTable", routerTable);

  //跳转之前的拦截
  context.$configure.set("routerBefore", routerBefore.bind(null, context));

  //验证token是否过期
  // context.$configure.set('validToken', validToken);

  //http请求基础路径
  context.$configure.set(
    "httpBaseUrl",
    process.env.NODE_ENV === "production"
      ? "/__api/"
      // : "http://47.105.197.148:5893/__api/"
    : "http://127.0.0.1:5891/"
  );
  //context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? '/__api/' : 'https://hanzkk.51vip.biz/');
  // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? '/__api/' : 'http://localhost:5891');
  // context.$configure.set('httpBaseUrl', process.env.NODE_ENV === 'production' ? '/__api/' : 'http://192.168.13.133:5891');

  //restApi
  context.$configure.set("restApi", restApi.bind(null, context));

  //httpMocks
  context.$configure.set("httpMocks", httpMocks);

  //
  context.$configure.set("httpSuccessHandler", function(response, cb) {
    let isJsonResponse = response.config.responseType === "json",
      isStreamResponse =
        response.headers["content-type"] === "application/octet-stream",
      isExcelResponse =
        response.headers["content-type"].indexOf("application/vnd.ms-excel") >
        -1,
      responseIsSuccess =
        response.data.code === 200 ||
        response.data.errcode === 0 ||
        (isJsonResponse && response.data) ||
        isStreamResponse ||
        isExcelResponse ||
        response.config.responseType === "blob";

    cb(responseIsSuccess);
  });

  //请求异常拦截
  // context.$configure.set('httpErrorHandler', function (error, cb) {
  //     cb();
  // });
  // //请求异常拦截
  context.$configure.set("httpErrorHandler", function(error, cb) {
    if (process.env.NODE_ENV === "production") {
      let custom =
        (error.request || (error.response || {}).request || {}).custom || {};
      // if (custom && Object.keys(custom).length > 0) {
      //     if (custom.options.url.includes('/push2DingTalk/robot/send')) {
      //         return;
      //     } else {
      //         let response = error.response || {};
      //
      //         context.$rootInstance.$api('user', 'pushError2DingTalk', {
      //             msgtype: 'text',
      //             text: {
      //                 content: `发卡生产接口异常\n请求地址：${custom.options.url}\n请求方式：${custom.method}\n请求参数：${custom.options.body}\n响应码：${response.status ? response.status : '未访问到服务器接口'}\n响应信息：${(response.data || '').message || ''}`
      //             }
      //         }, error => {
      //             console.log('已推送异常消息...')
      //         });
      //     }
      // }
    }

    if (
      error.response &&
      [401, 901, 400].includes((error.response.data || {}).code)
    ) {
      context.$rootInstance.$jump("/login");
      context.$rootInstance.$nextTick(function() {
        context.$rootInstance.$busBroadcast("user-auth-fail", error);
      });
    } else {
      cb();
    }
  });
}



// WEBPACK FOOTER //
// ./src/configure/index.js